import { useCallback } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { showCartToast } from "../../../common/slices/cartToastSlice";
import { CartLabels } from "../utils/cartLabels";

interface UseCartToastsReturn {
    showSuccessToast: () => void;
    showRemovedToast: (productId: number) => void;
    showErrorToast: () => void;
}

export const useCartToasts = (cartLabels: CartLabels): UseCartToastsReturn => {
    const dispatch = useAppDispatch();

    const showSuccessToast = useCallback(() => {
        dispatch(
            showCartToast({
                variant: "success",
                message: cartLabels.addedToast,
                actionLabel: cartLabels.viewCartLabel,
                actionType: "viewCart",
            }),
        );
    }, [dispatch, cartLabels.addedToast, cartLabels.viewCartLabel]);

    const showRemovedToast = useCallback(
        (productId: number) => {
            dispatch(
                showCartToast({
                    variant: "default",
                    message: cartLabels.removedToast,
                    actionLabel: cartLabels.undoLabel,
                    actionType: "undo",
                    undoProductId: productId,
                    showIcon: false,
                }),
            );
        },
        [dispatch, cartLabels.removedToast, cartLabels.undoLabel],
    );

    const showErrorToast = useCallback(() => {
        dispatch(
            showCartToast({
                variant: "error",
                message: cartLabels.reserveFailedToast,
            }),
        );
    }, [dispatch, cartLabels.reserveFailedToast]);

    return { showSuccessToast, showRemovedToast, showErrorToast };
};
